import React from "react";
import { useImage } from "@hooks/useImage";
import { useRoutes } from "@hooks/useRoutes";
import { useAnalytics } from "@hooks/useAnalytics";
import { useHelper } from "@hooks/useHelper";

export const withHero =
  (Component) =>
  ({ name = "Hero", analytics = {}, content, heroContent, ...props }) => {
    const { getFluidImage } = useImage();
    const { linkResolver } = useRoutes();
    const { trackPromoClick } = useAnalytics();
    const { handleClickOnCustomContentLink } = useHelper();
    const normalisedContent = content || heroContent;
    const items = normalisedContent?.map((item) => ({
      image: getFluidImage(item?.image, { layout: "fullWidth" }),
      link: linkResolver(item?.buttonLink),
      imageLink:
        item?.imageLink && item?.imageLink.length
          ? item.imageLink[0]?.external
            ? item.imageLink[0]
            : linkResolver(item.imageLink[0])
          : null,
    }));

    const handleClickImage = (imageLink) => {
      trackPromoClick({ ...analytics });
      handleClickOnCustomContentLink(imageLink);
    };

    Component.displayName = name;
    return (
      <Component
        {...props}
        items={items}
        onClickImage={handleClickImage}
        handleClick={trackPromoClick({ ...analytics })}
      />
    );
  };
